/**
 * TODO
 * We currently have too many dependencies on state.PlanSelectionNewWhatIfs
 * When we migrate the plan management into react-query we should replace this hook
 * with an actual usePlansQuery hook.
 */

import { useSelector } from 'react-redux';

const plansSelector = state => state.PlanSelectionNewWhatIfs;

export interface PlanDTO {
  planId: string;
  name: string;
  description: string | null;
  isCurrent: boolean;
}

interface UsePlansParams {
  clientId: string;
}

export const usePlans = ({ clientId }: UsePlansParams): PlanDTO[] => {
  const plans = useSelector(plansSelector)[clientId];

  return plans?.allPlans || [];
};
